// Mock data pour la landing page Vita Liberté

export const gymInfo = {
  name: "Vita Liberté Bagnols-sur-Cèze",
  address: "138 Avenue de la Roquette",
  postalCode: "30200",
  city: "Bagnols-sur-Cèze",
  phone: "09 86 45 33 88",
  email: "vitalibertebagnols@gmail.com",
  openingHours: "7j/7 de 6h à 23h",
  mapLink: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2870.234!2d4.617987!3d44.161234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b5b4c0a5d9f6a9%3A0x5e8f3c1d2a6b7c8d!2sVita%20Libert%C3%A9%20Bagnols-sur-Ceze!5e0!3m2!1sfr!2sfr!4v1234567890!5m2!1sfr!2sfr"
};

export const testimonials = [
  {
    id: 1,
    name: "Sophie M.",
    text: "Une salle propre, bien équipée et ouverte à des horaires parfaits pour mon travail. Je recommande !",
    rating: 5
  },
  {
    id: 2,
    name: "Thomas L.",
    text: "Ambiance conviviale, machines modernes et accès simple. Idéal pour progresser.",
    rating: 5
  },
  {
    id: 3,
    name: "Marie D.",
    text: "Enfin une salle où je peux m'entraîner à mon rythme sans contrainte.",
    rating: 5
  }
];

export const trainingSpaces = [
  {
    id: 1,
    title: "Musculation",
    description: "Un espace complet avec machines guidées et charges libres pour développer votre masse musculaire, votre force et votre tonicité.",
    image: "https://customer-assets.emergentagent.com/job_musculation-fitness/artifacts/v5ug1ex4_PXL_20260227_093054091.jpg"
  },
  {
    id: 2,
    title: "Cardio Training",
    description: "Tapis de course, vélos, elliptiques et rameurs pour améliorer votre endurance, brûler des calories et booster votre condition physique.",
    image: "https://customer-assets.emergentagent.com/job_musculation-fitness/artifacts/4heec5io_PXL_20260227_093035040.jpg"
  },
  {
    id: 3,
    title: "Espace Extérieur",
    description: "Entraînez-vous en plein air dans notre espace fitness extérieur équipé pour des séances dynamiques et motivantes.",
    image: "https://customer-assets.emergentagent.com/job_musculation-fitness/artifacts/7d72ov6d_Espace%20fitness%20ext%C3%A9rieur%20moderne.png"
  },
  {
    id: 4,
    title: "Accueil & Détente",
    description: "Un espace d'accueil chaleureux avec distributeurs de boissons et compléments pour optimiser vos performances.",
    image: "https://customer-assets.emergentagent.com/job_musculation-fitness/artifacts/z4y0eqty_PXL_20260227_093110462.jpg"
  }
];

export const benefits = [
  "Accès 7j/7 de 6h à 23h",
  "Abonnement sans contrainte",
  "Machines professionnelles récentes",
  "Accès aux clubs Vita Liberté partout en France",
  "Ambiance conviviale et motivante"
];

export const objectives = [
  { id: 1, title: "Perte de poids", icon: "target" },
  { id: 2, title: "Prise de masse musculaire", icon: "dumbbell" },
  { id: 3, title: "Remise en forme", icon: "heart" },
  { id: 4, title: "Préparation physique", icon: "zap" },
  { id: 5, title: "Amélioration du cardio", icon: "activity" },
  { id: 6, title: "Bien-être et santé", icon: "smile" }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Freedom",
    price: "€69.70",
    period: "pour 2 mois",
    description: "L'offre sans engagement",
    features: [
      "Accès illimité 7j/7",
      "Tous les équipements",
      "Cours interactifs",
      "Sans engagement",
      "Accès à tous les clubs"
    ],
    note: "Hors frais d'inscription",
    highlight: false
  },
  {
    id: 2,
    name: "Classique",
    price: "€26.90",
    period: "par mois",
    description: "Le meilleur rapport qualité-prix",
    features: [
      "Accès illimité 7j/7",
      "Tous les équipements",
      "Cours interactifs",
      "Engagement 12 mois",
      "Accès à tous les clubs"
    ],
    highlight: false
  },
  {
    id: 3,
    name: "Suivi",
    price: "€34.90",
    period: "par mois",
    description: "Idéal pour commencer",
    features: [
      "Accès illimité 7j/7",
      "Tous les équipements",
      "Cours interactifs",
      "Engagement 12 mois",
      "Accès à tous les clubs",
      "1 suivi au choix : nutrition OU coaching sportif"
    ],
    highlight: true
  },
  {
    id: 4,
    name: "Full",
    price: "€38.90",
    period: "par mois",
    description: "L'offre la plus complète",
    features: [
      "Accès illimité 7j/7",
      "Tous les équipements",
      "Cours interactifs",
      "Engagement 12 mois",
      "Accès à tous les clubs",
      "2 coachings tous les mois",
      "-10% sur les compléments alimentaires"
    ],
    highlight: false
  }
];

export const creneaux = [
  "Matin (6h-9h)",
  "Matinée (9h-12h)",
  "Midi (12h-14h)",
  "Après-midi (14h-18h)",
  "Soirée (18h-23h)"
];

export const coaches = [
  {
    id: 1,
    name: "MAXIME DOUARD",
    speciality: "Coach Musculation & Nutrition",
    description: "Spécialiste en protocole musculaire, Maxime vous aide à atteindre vos objectifs avec des programmes adaptés et un suivi nutritionnel personnalisé.",
    image: "https://customer-assets.emergentagent.com/job_musculation-fitness/artifacts/qhyi010q_IMG_0564.JPG",
    isMain: true
  }
];

export const apprentices = [];

export const faqItems = [
  {
    id: 1,
    question: "La séance d'essai est-elle vraiment gratuite ?",
    answer: "Oui ! Votre première séance d'essai est 100% gratuite et sans engagement. C'est l'occasion de découvrir nos équipements, rencontrer nos coachs et tester l'ambiance de la salle."
  },
  {
    id: 2,
    question: "Puis-je venir sans expérience en musculation ?",
    answer: "Absolument ! Notre salle accueille tous les niveaux, des débutants aux confirmés. Nos coachs sont là pour vous guider et vous montrer les bons gestes dès le début."
  },
  {
    id: 3,
    question: "Quels sont les horaires d'accès ?",
    answer: "La salle est accessible 7j/7 de 6h à 23h. L'accueil est présent du lundi au jeudi de 9h à 19h, le vendredi de 9h à 18h et le samedi de 9h à 12h."
  },
  {
    id: 4,
    question: "Y a-t-il un engagement avec les abonnements ?",
    answer: "Nous proposons plusieurs formules : la formule Freedom sans engagement, et des formules avec engagement 12 mois à tarif préférentiel. Vous choisissez ce qui vous convient !"
  },
  {
    id: 5,
    question: "Puis-je accéder aux autres salles Vita Liberté ?",
    answer: "Oui ! Votre abonnement vous donne accès à toutes les salles Vita Liberté en France, idéal si vous voyagez."
  },
  {
    id: 6,
    question: "Comment se passe le coaching ?",
    answer: "Selon votre formule, vous bénéficiez de 1 ou 2 séances de coaching par mois. Le coach crée un programme personnalisé et vous accompagne pour optimiser vos résultats."
  }
];

export const mission = {
  title: "Notre Mission",
  subtitle: "Vous accompagner vers votre meilleure version",
  description: "Chez Vita Liberté Bagnols-sur-Cèze, nous croyons que chacun mérite d'atteindre ses objectifs fitness dans un environnement motivant et bienveillant. Notre équipe de coachs passionnés est là pour vous guider, vous encourager et célébrer chaque progrès avec vous.",
  values: [
    {
      id: 1,
      title: "Accompagnement personnalisé",
      description: "Des coachs à votre écoute qui adaptent les programmes à vos besoins"
    },
    {
      id: 2,
      title: "Ambiance conviviale",
      description: "Un club où vous vous sentez bien, entouré de personnes motivées"
    },
    {
      id: 3,
      title: "Équipements modernes",
      description: "Du matériel professionnel récent pour des entraînements efficaces"
    }
  ]
};

// Transformations et résultats
export const transformations = [
  {
    id: 1,
    name: "Sophie L.",
    result: "-12kg en 3 mois",
    testimonial: "J'ai enfin retrouvé confiance en moi ! Les coachs m'ont accompagnée tout au long de ma transformation.",
    program: "Programme perte de poids + nutrition"
  },
  {
    id: 2,
    name: "Thomas M.",
    result: "+8kg de muscle en 6 mois",
    testimonial: "Grâce au suivi personnalisé de Maxime, j'ai pris du muscle sec et amélioré mes performances.",
    program: "Programme prise de masse"
  },
  {
    id: 3,
    name: "Marie D.",
    result: "-15kg en 5 mois",
    testimonial: "Un accompagnement au top ! J'ai perdu du poids durablement avec un suivi nutrition adapté.",
    program: "Forfait Full avec coaching"
  },
  {
    id: 4,
    name: "Julien R.",
    result: "Remise en forme complète",
    testimonial: "Après 2 ans sans sport, j'ai retrouvé la forme en 4 mois. Ambiance motivante et équipe au top !",
    program: "Remise en forme progressive"
  }
];

// Stats live
export const liveStats = {
  members: 350,
  transformations: 120,
  satisfaction: 98
};

// Programme de parrainage
export const referralProgram = {
  title: "Parrainez un Ami, Gagnez 1 Mois Offert !",
  description: "Vous aimez Vita Liberté ? Faites-le savoir et soyez récompensé !",
  benefits: [
    "1 mois d'abonnement offert pour vous (le parrain)",
    "Parrainage illimité : plus vous parrainez, plus vous gagnez !",
    "Aidez vos proches à découvrir Vita Liberté",
    "Simple et rapide : ils mentionnent juste votre nom à l'inscription"
  ],
  howItWorks: [
    "Parlez de Vita Liberté à vos proches",
    "Ils mentionnent votre nom lors de leur inscription",
    "Vous recevez 1 mois offert dès validation de leur abonnement",
    "Profitez et recommencez !"
  ]
};

// Événements et challenges
export const upcomingEvents = [
  {
    id: 1,
    title: "Challenge 30 Jours",
    date: "Du 1er au 30 juin 2026",
    description: "Participez à notre challenge collectif : 30 jours de training avec objectifs personnalisés. Gagnez des récompenses !",
    type: "Challenge",
    icon: "trophy"
  },
  {
    id: 2,
    title: "Portes Ouvertes",
    date: "Samedi 15 juin 2026",
    description: "Venez découvrir la salle, rencontrer les coachs et tester les équipements gratuitement de 10h à 18h.",
    type: "Événement",
    icon: "door-open"
  },
  {
    id: 3,
    title: "Atelier Nutrition",
    date: "Mercredi 19 juin 2026 à 19h",
    description: "Atelier gratuit avec Maxime : Comment optimiser votre nutrition pour atteindre vos objectifs.",
    type: "Atelier",
    icon: "apple"
  }
];

// Planning des coachs
export const coachSchedule = {
  MAXIME: {
    name: "MAXIME DOUARD",
    days: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    timeSlots: {
      "Lundi": ["9h-10h", "10h-11h", "11h-12h", "15h-16h", "16h-17h", "17h-18h"],
      "Mardi": ["9h-10h", "10h-11h", "11h-12h", "15h-16h", "16h-17h", "17h-18h"],
      "Mercredi": ["9h-10h", "10h-11h", "11h-12h", "15h-16h", "16h-17h", "17h-18h"],
      "Jeudi": ["9h-10h", "10h-11h", "11h-12h", "15h-16h", "16h-17h", "17h-18h"],
      "Vendredi": ["9h-10h", "10h-11h", "11h-12h", "15h-16h", "16h-17h", "17h-18h"],
      "Samedi": ["9h-10h", "10h-11h", "11h-12h"]
    }
  }
};
